import React from 'react';
import { fmtDateTime } from '../../lib/format';
import { History, SearchX } from 'lucide-react';

export const InfoRow = ({ label, value, testId }) => (
  <div className="flex items-start justify-between gap-3 py-1">
    <span className="text-xs text-muted-foreground shrink-0">{label}</span>
    <span className="text-xs font-medium text-right" data-testid={testId}>{value || '\u2014'}</span>
  </div>
);

export const ActivityList = ({ items }) => (
  <div className="space-y-2" data-testid="summary-activity-list">
    <div className="text-xs font-semibold flex items-center gap-1.5"><History size={12} /> Last 3 Activities</div>
    {items.length === 0 && <div className="text-xs text-muted-foreground">No activity recorded yet</div>}
    {items.map((a) => (
      <div key={a.id} className="rounded-lg border bg-muted/30 p-2" data-testid={`summary-activity-${a.id}`}>
        <div className="flex items-center justify-between">
          <span className="text-[11px] font-semibold capitalize">{String(a.action).replace(/_/g, ' ')}</span>
          <span className="text-[10px] text-muted-foreground">{fmtDateTime(a.created_at)}</span>
        </div>
        <div className="text-[10px] text-muted-foreground">by {a.user_name}{a.lead_name ? ` \u00b7 ${a.lead_name}` : ''}</div>
        {(a.changes || []).slice(0, 2).map((c, i) => (
          <div key={`${c.field}-${i}`} className="text-[11px] mt-0.5">
            <span className="text-muted-foreground">{c.label}:</span> <span className="font-medium">{c.new}</span>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export const PanelError = ({ notFound }) => (
  <div className="py-12 text-center space-y-2" data-testid={notFound ? 'summary-not-found' : 'summary-load-error'}>
    <SearchX size={28} className="mx-auto text-muted-foreground/50" />
    <div className="text-sm font-medium">{notFound ? 'Record not found' : 'Could not load this record'}</div>
    <div className="text-xs text-muted-foreground">
      {notFound ? 'It may have been deleted or archived, or you may not have access to it.'
        : 'Something went wrong while loading. Please try again.'}
    </div>
  </div>
);
